<div class="modal fade modal"
  id="modal-alternative" tabindex="-1" role="dialog"
  data-backdrop="static" [ngClass]="{'modal-confirm': content.typeModal === 'modal-confirm'}">

  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <!-- body -->
        <div class="div-body">

          <!-- image --> <!-- Small Responsive Screen -->
          @if (content.imgLateral) {
            <div class="d-block d-lg-none">
              <img src="assets/images/backgrounds/identity_validation_issues_mobil.png" class="img-mobil" alt="Validacion exitosa">
            </div>
          }

          <!-- image --> <!-- Normal Screen -->
          @if (content.imgLateral) {
            <div class="d-none d-lg-block">
              <img src="assets/images/backgrounds/identity_validation_issues.png" class="icon" alt="Validacion exitosa">
            </div>
          }

          <!-- content -->
          <div class="col-lg-6 d-lg-block p-5 text-left">
            <!-- title -->
            <div class="title">
              {{ content.titulo }}
            </div>

            <!-- description -->
            <div class="txt p-2">
              <p  [innerHTML]="content.textoHTML">
              </p>
            </div>

            <!-- button(s) -->
            @if ((content.buttonDataList !== null) && (content.buttonDataList.length > 0)) {
              <div class="container-button">
                @for (button of content.buttonDataList; track button) {
                  <button class="btn-lg btn text-center d-block btn-primary-alternative"
                    [ngClass]="{'btn-orange': button.class === 'btn-orange', 'btn-transparent': button.class === 'btn-transparent'}"
                    (click)="content.redirect(button.enlaceBoton)" data-dismiss="modal">
                    {{ button.textBoton }} <i class="arrow right"></i>
                  </button>
                }
              </div>
            }

            <!-- additional message -->
            @if ((content.alternativeMessage !== null) && (content.alternativeMessage !== '')) {
              <div class="p-1">
                <p [innerHTML]="content.alternativeMessage">
                </p>
              </div>
            }

          </div>

          <!-- button-close -->
          <div class="div-close-btn">
            <button type="button" class="close-btn-icon" data-dismiss="modal" aria-label="Close" >
              <img src="/assets/images/close-button.svg" alt="Icon" class="icon-img-close">
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>
